var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgExclamationNew = function SvgExclamationNew(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 14,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC5D3C",
    d: "M2.015 10.468c-.808 0-1.485.677-1.485 1.485s.677 1.485 1.485 1.485c.778 0 1.485-.677 1.45-1.45a1.45 1.45 0 0 0-1.45-1.52M1.647.042C.94.244.5.885.5 1.664c.036.469.065.944.101 1.414l.303 5.328a1.09 1.09 0 0 0 1.11 1.046c.607 0 1.082-.47 1.112-1.081 0-.369 0-.707.035-1.082.066-1.146.137-2.293.202-3.44.036-.742.101-1.484.137-2.227 0-.267-.036-.505-.137-.742A1.49 1.49 0 0 0 1.647.042"
  })));
};
export default SvgExclamationNew;